<div class="main-container">
	<div class="header">
		<h4>
			<span>{{binderDetails.binderName}} Binder</span>
		</h4>
		<h4>		
			<span>Jobs list</span>
		</h4>
	</div>
	<div class="items-list">
		<p class="empty-message-container" *ngIf="!digitalLogbooks?.length">There are no jobs</p>
		<div class="job-container" *ngFor="let job of digitalLogbooks">
			<a mat-flat-button [href]="job.urlHash + '/digital-log'">
				<p class="job-name-container">
					<span>{{job.jobName}}</span>
				</p>
				<span *ngIf="job.siteName">{{ job.siteAddress }}</span>
				<span class="job-asset" *ngIf="job.asset">{{ job.asset }}</span>
				<span>Last Submitted On:
					{{ job.lastSavedDate ? moment.parseZone(job.lastSavedDate).format('dddd, MM/DD/YYYY') : 'N/A' }}
				</span>
			</a>
		</div>
	</div>
</div>
